import NavbarComponent from "../components/NavbarComponent";

import "../styles/projects/project-main.css";
import { Alert, Container } from "react-bootstrap";
import { TechnologyBadgeComponent } from "../components/TechnologyBadgeComponent";
import projectsData from "../data/projects.json";
import { useLocation } from "react-router-dom";
import ProjectScreenshotsComponent from "../components/ProjectScreenshotsComponent";
import BrowseProjectsComponent from "../components/BrowseProjectsComponent";
import BackButtonComponent from "../components/BackButtonComponent";
import DemoButtonsComponent from "../components/DemoButtonsComponent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTools } from "@fortawesome/free-solid-svg-icons";

const Pixelate = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const fetchProjectData = projectsData.data.filter(
    (item) => item.projectLink === pathname
  );
  const projectData = fetchProjectData[0];

  return (
    <>
      <NavbarComponent />

      <div className="project-body">
        <Container>
          <BackButtonComponent />

          <Alert
            variant="info"
            className="mb-4 d-flex align-items-center gap-2"
          >
            <FontAwesomeIcon icon={faTools} />
            <span>
              <strong>Heads up!</strong> Pixelate is actively evolving — new
              features and improvements are being added regularly.
            </span>
          </Alert>

          <h1 className="project-page-title">{projectData.title}</h1>
          <h2 className="project-page-subtitle text-white">
            {projectData.subtitle}
          </h2>

          <TechnologyBadgeComponent
            technologiesList={projectData.technologies}
          />

          <DemoButtonsComponent projectData={projectData} />

          <ProjectScreenshotsComponent imagesList={projectData.sampleImages} />

          <BrowseProjectsComponent projectsListData={projectsData.data} />
        </Container>
      </div>
    </>
  );
};

export default Pixelate;
